import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useTranslation } from 'react-i18next';

/**
 * Full "Title - Artist" of a row that does not fit the list width. Opened from the
 * inline "...more" link, which only appears when the text is actually cut off.
 */
export const SongFullNameModal = ({ text, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal isOpen={!!text} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>{t('Song')}</ModalHeader>
      <ModalBody>
        <div className="text-break fs-15">{text}</div>
      </ModalBody>
      <ModalFooter>
        <div className="hstack gap-2 justify-content-end">
          <button type="button" className="btn btn-label btn-light" onClick={onClose}>
            <i className="ri-close-circle-line label-icon align-middle fs-16 me-2"></i>{t('Close')}
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
};
